import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_ENDPOINTS, fetchFromApi } from '../config/api';
import { FaYoutube, FaBandcamp } from 'react-icons/fa';
import '../styles/Releases.css';

const Releases = () => {
  const navigate = useNavigate();
  const [releases, setReleases] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch releases from API
  useEffect(() => {
    const fetchReleases = async () => {
      try {
        setLoading(true);
        const data = await fetchFromApi(API_ENDPOINTS.releases, {
          method: 'GET',
          mode: 'cors'
        });

        if (!data) {
          setReleases([]);
          return;
        }

        const transformedReleases = data.map(release => ({
          id: release.id,
          title: release.title,
          artist: release.artist,
          releaseDate: release.release_date,
          label: release.label || 'Independent',
          genres: release.genres || [],
          // Handle tracklist stored as { tracks: [...] } or direct array
          tracklist: Array.isArray(release.tracklist) 
            ? release.tracklist 
            : (release.tracklist?.tracks || []),
          links: release.links || {},
          artwork: release.artwork_url || '/images/releases/release-placeholder.png'
        }));

        // Only show first 2 releases on landing page
        setReleases(transformedReleases.slice(0, 2));
      } catch (err) {
        console.error('Error fetching releases:', err);
        setReleases([]);
      } finally {
        setLoading(false);
      }
    };

    fetchReleases();
  }, []);

  if (loading) {
    return null;
  }

  if (!releases.length) {
    return null;
  }

  return (
    <section id="releases" className="releases-section">
      <div className="section-content">
        <h2>RELEASES</h2>
        <div className="releases-grid">
          {releases.map(release => (
            <div key={release.id} className="release-card">
              <a 
                href={release.links.bandcamp} 
                target="_blank" 
                rel="noopener noreferrer"
                className="release-artwork"
              >
                <img
                  src={release.artwork}
                  alt={`${release.title} by ${release.artist}`}
                  loading="lazy"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.parentElement.style.background = 'linear-gradient(45deg, #2a2a2a, #3a3a3a)';
                  }}
                />
              </a>
              <div className="release-info">
                <h3>{release.artist && release.title ? `${release.artist} - ${release.title}` : release.title}</h3>
                <p className="release-date">
                  {`TLL-${String(release.id).padStart(3, '0')} - ${new Date(release.releaseDate + 'T00:00:00').toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}`}
                </p>
                {(release.links.youtube || release.links.bandcamp) && (
                  <div className="social-links">
                    {release.links.bandcamp && (
                      <a 
                        href={release.links.bandcamp} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="social-link bandcamp"
                        title="Listen on Bandcamp"
                      >
                        <FaBandcamp />
                      </a>
                    )}
                    {release.links.youtube && (
                      <a 
                        href={release.links.youtube} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="social-link youtube"
                        title="Watch on YouTube"
                      >
                        <FaYoutube />
                      </a>
                    )}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        <button className="see-more-btn" onClick={() => navigate('/releases')}>
          See More Releases
        </button>
      </div>
    </section>
  );
};

export default Releases;
